import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=22143180&"
import script from "./ErrorPage.vue?vue&type=script&lang=ts&"
export * from "./ErrorPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports